import { useDispatch } from 'react-redux';

import { MainStoreDispatch } from 'store/MainStoreDispatch';

export const useMainDispatch: () => MainStoreDispatch = useDispatch;
